import type { AssetEntity, AssetUpdateVariables } from "./asset.type";
import type { UseUpdateOptions } from "@/hooks/queries";

import { useUpdate } from "@/hooks/queries";

export const useAssetUpdate = (
  assetId: number,
  options?: UseUpdateOptions<AssetEntity, AssetUpdateVariables>
) => {
  return useUpdate<AssetEntity, AssetUpdateVariables>(
    "assets",
    assetId,
    options
  );
};
